import { ChevronRight, type LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface NavRowProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  /**
   * Optional leading icon (decorative — the label carries the meaning).
   * Monochrome muted, consistent 18px; the active row inherits the
   * primary-foreground color instead.
   */
  icon?: LucideIcon;
}

/**
 * A settings navigation row that opens a middle-column view. Extracted from
 * PaymentsTab so the flat settings list (flag `settingsMiddleViews`) and the
 * legacy payments accordion share one row component.
 */
export default function NavRow({
  label,
  isActive,
  onClick,
  icon: Icon,
}: NavRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center rounded-md px-3 py-2 text-sm font-normal",
        isActive
          ? "bg-primary text-primary-foreground"
          : "text-foreground hover:bg-muted",
      )}
    >
      {Icon && (
        <Icon
          aria-hidden
          className={cn(
            "mr-3 size-[18px] shrink-0",
            !isActive && "text-muted-foreground",
          )}
        />
      )}
      {label}
      <ChevronRight className="ml-auto size-4" />
    </button>
  );
}
